import React from "react";
import DocTransmittalTable from "./Table";
import { useDocTransmittalContext } from "./DocTransmittal.context";
import { Tab, Tabs } from "@mui/material";
import TabPanel from "../../../../../../components/Tabs/TabPanel.component";
import OldDocumentTransmittalTab from "./OldIndexForModal";

const tabs = [
  {
    label: "All",
    panel: <DocTransmittalTable to="Receiver" />,
  },
  {
    label: "Clients",
    panel: <DocTransmittalTable to="Client" />,
  },
  {
    label: "Vendors",
    panel: <DocTransmittalTable to="Vendor" />,
  },
  {
    label: "Archived",
    panel: <DocTransmittalTable to="Receiver" isArchived />,
  },

  {
    label: "Closed",
    panel: <DocTransmittalTable to="Receiver" closed />,
  },

  // {
  //   label: "Rev0",
  //   panel: <OldDocumentTransmittalTab />,
  // },
];
export default function DocTransmittalTabs() {
  const { tab, handleChangeTab } = useDocTransmittalContext();

  return (
    <Tabs value={tab} onChange={handleChangeTab} sx={{ ml: 10 }}>
      {tabs.map((t) => (
        <Tab key={t.label} label={t.label} value={t.label} />
      ))}
    </Tabs>
  );
}

export const DocTransmittalTabsPanels = () => {
  const { tab } = useDocTransmittalContext();
  return (
    <>
      {tabs.map((t, i) => {
        return (
          <TabPanel value={tab} index={t.label} key={t.label}>
            {t.panel}
          </TabPanel>
        );
      })}
    </>
  );
};
